export async function getTitlesApi() {
  let response = await fetch(process.env.REACT_APP_API_ROOT + "titles");

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function delTitleApi(id) {
  let response = await fetch(process.env.REACT_APP_API_ROOT + "titles/" + id, {
    method: "DELETE"
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function createTitleApi(name, productionTitle) {
  let response = await fetch(process.env.REACT_APP_API_ROOT + "titles", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    },
    body: new URLSearchParams({
      name: name,
      production_title: productionTitle
    })
  });

  let data = await response.json();

  if (!response.ok) {
    throw Error(response.statusText);
  }

  return data;
}

export async function editTitleApi(id, newName) {
  let response = await fetch(process.env.REACT_APP_API_ROOT + "titles/" + id, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    },
    body: new URLSearchParams({
      name: newName
    })
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function getATitleApi(titleID) {
  let response = await fetch(
    process.env.REACT_APP_API_ROOT + "titles/" + titleID
  );

  if (!response.ok) {
    if (response.status === 404) {
      throw Error(404);
    } else {
      throw Error(response.statusText);
    }
  }

  let data = await response.json();

  return data;
}
